module.exports = __webpack_public_path__ + "img/KSC08583.2999f35c.jpg";